import documents from './documents';

const config = {
  ext: { id: 'dmcinkihbalbalneakclgkkjpceaaglo' },
  documents,
};

export default config;
